// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/Width.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, css } from '@sail/ui';
import { EXAMPLE_TEXT } from './common'; // TODO: width is currently still broken when not using `&&`

export const Width = () => <TextArea label="App feedback" defaultValue={EXAMPLE_TEXT} css={{
  width: css.value('350px')
}} />;